import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';
import SpinCentered from '@/comp/SpinCentered';

import ImageUpload from './ImageUpload/ImageUpload';
import ImageList from './ImageList/ImageList';
import { permissions } from '@/constants';

const AssetImages = observer(({ deviceId }: { deviceId: string }) => {
  const { devicesStore, imageUploadStore, permissionStore } = useStores();

  useEffect(() => {
    const fetchDeviceImages = async () => {
      imageUploadStore.reset();
      imageUploadStore.setDeviceId(deviceId);
      await devicesStore.getDeviceImages(deviceId);
      imageUploadStore.setNoEditPermission(!permissionStore.isAuth(permissions.UPDATE_DEVICE_IMAGES));
    };
    fetchDeviceImages();
  }, [deviceId]);

  if (devicesStore.isLoadingDeviceImages) {
    return <SpinCentered />;
  }

  return devicesStore.deviceImages?.length > 0 ? <ImageList deviceId={deviceId} /> : <ImageUpload deviceId={deviceId} />;
});

export default AssetImages;
